module.exports = __webpack_public_path__ + "img/syugr_logo_highlight.0424b0ea.svg";